import React, { useState } from "react";

const emailPattern = /^\S+@\S+\.\S+$/;

function SummerProgramRegistrationForm({
  programName,
  paymentOpen,
  cancellationPolicy,
  onSubmit,
  isSubmitting,
}) {
  const [formData, setFormData] = useState({
    studentName: "",
    studentEmail: "",
    studentGrade: "",
    parentName: "",
    parentEmail: "",
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case "studentName":
        return value.trim() ? "" : "Student's name is required";
      case "studentEmail":
        if (!value.trim()) return "Student's email is required";
        return emailPattern.test(value) ? "" : "Invalid student email address";
      case "studentGrade":
        return value.trim() ? "" : "Student's grade is required";
      case "parentName":
        return value.trim() ? "" : "Parent's name is required";
      case "parentEmail":
        if (!value.trim()) return "Parent's email is required";
        return emailPattern.test(value) ? "" : "Invalid parent email address";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) {
        newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAction = (registrationAction) => {
    if (!validateForm()) {
      return;
    }

    onSubmit({ ...formData, programName, registrationAction });
  };

  const isSubmitDisabled =
    !formData.studentName ||
    !formData.studentEmail ||
    !formData.studentGrade ||
    !formData.parentName ||
    !formData.parentEmail ||
    Object.values(errors).some((error) => error !== "") ||
    isSubmitting;

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <label htmlFor="studentName">Student&apos;s Name *</label>
      <input
        type="text"
        id="studentName"
        name="studentName"
        value={formData.studentName}
        onChange={handleChange}
        required
      />
      {errors.studentName && (
        <span className="registration-form-error">{errors.studentName}</span>
      )}

      <label htmlFor="studentEmail">Student&apos;s Email *</label>
      <input
        type="email"
        id="studentEmail"
        name="studentEmail"
        value={formData.studentEmail}
        onChange={handleChange}
        required
      />
      {errors.studentEmail && (
        <span className="registration-form-error">{errors.studentEmail}</span>
      )}

      <label htmlFor="studentGrade">Student&apos;s Grade *</label>
      <input
        type="text"
        id="studentGrade"
        name="studentGrade"
        value={formData.studentGrade}
        onChange={handleChange}
        required
      />
      {errors.studentGrade && (
        <span className="registration-form-error">{errors.studentGrade}</span>
      )}

      <label htmlFor="parentName">Parent&apos;s Name *</label>
      <input
        type="text"
        id="parentName"
        name="parentName"
        value={formData.parentName}
        onChange={handleChange}
        required
      />
      {errors.parentName && (
        <span className="registration-form-error">{errors.parentName}</span>
      )}

      <label htmlFor="parentEmail">Parent&apos;s Email *</label>
      <input
        type="email"
        id="parentEmail"
        name="parentEmail"
        value={formData.parentEmail}
        onChange={handleChange}
        required
      />
      {errors.parentEmail && (
        <span className="registration-form-error">{errors.parentEmail}</span>
      )}

      {paymentOpen ? (
        <div className="registration-payment-info">
          <p>
            <strong>Limited seats available.</strong> Due to limited capacity, we only
            reserve seats for paid registrations. Unpaid registrations do not
            guarantee a spot.
          </p>
          <p>
            We use Stripe to process card payments. Stripe processing fees are added
            at checkout. After payment, you will return to our site and receive a
            confirmation email.
          </p>
          <p>
            <strong>Cancellation policy:</strong>{" "}
            {cancellationPolicy ||
              "Please contact Seattle Voctech School for cancellation information."}
          </p>
        </div>
      ) : (
        <div className="registration-payment-info">
          <p>
            <strong>This program has already started.</strong> Payment is no longer
            available.
          </p>
          <p>
            You may still submit your information below to receive updates about
            future program opportunities from Seattle Voctech School.
          </p>
        </div>
      )}

      <div className="registration-form-actions">
        {paymentOpen ? (
          <>
            <input
              type="button"
              value="Register & Pay Later"
              disabled={isSubmitDisabled}
              onClick={() => handleAction("pay_later")}
            />
            <input
              type="button"
              className="registration-pay-now-button"
              value="Register & Pay Now"
              disabled={isSubmitDisabled}
              onClick={() => handleAction("pay_now")}
            />
          </>
        ) : (
          <input
            type="button"
            value="Receive Future Information"
            disabled={isSubmitDisabled}
            onClick={() => handleAction("future_interest")}
          />
        )}
      </div>
    </form>
  );
}

export default SummerProgramRegistrationForm;
